export const SECRET_KEY = Object.freeze({
  ACCESS_TOKEN: process.env.VUE_APP_TOKEN,
  REFRESH_TOKEN: process.env.VUE_APP_REFRESH_TOKEN,
  AUTHENTICATION: process.env.VUE_APP_AUTHENTICATION,
});